import { render, staticRenderFns } from "./MassenmutationModalGeneric.vue?vue&type=template&id=2fe30eda&"
import script from "./MassenmutationModalGeneric.vue?vue&type=script&lang=js&"
export * from "./MassenmutationModalGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports